class Dropdown {
	constructor(el) {
		this.el = el;
		this.selector = this.el.getAttribute('data-dropdown') || '.dropdown';
		this.target = document.querySelector(this.selector);

		this.el.addEventListener('click', this.toggle.bind(this));

		$(document).on('click', this.hide.bind(this));
	}

	toggle(e) {
		e.stopPropagation();

		const isHidden = this.target.className.indexOf('hidden') > -1;

		if (isHidden) {
			this.target.className = this.target.className.replace(/\bhidden\b/,'');
		} else {
			this.target.className += ' hidden';
		}
	}

	hide(e) {
		if(!$(e.target).closest(this.selector).length && !$(event.target).is(this.selector)) {
			if($(this.target).is(":visible")) {
				$(this.target).addClass('hidden');
			}
		}
	}
}

export default Dropdown


// WEBPACK FOOTER //
// ./src/desktop/scripts/ui/dropdown.js